import { render, staticRenderFns } from "./space_utilization_top10.vue?vue&type=template&id=0043cdfc"
import script from "./space_utilization_top10.vue?vue&type=script&lang=js"
export * from "./space_utilization_top10.vue?vue&type=script&lang=js"
import style0 from "./space_utilization_top10.vue?vue&type=style&index=0&id=0043cdfc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports